export const cleanExpression = (expr) => {
  if (!expr) return expr;

  if (expr.TYPE === "REFERENCE" || expr.TYPE === "LITERAL") {
    return { TYPE: expr.TYPE, VALUE: expr.VALUE ?? "" };
  }

  if (expr.TYPE === "OPERATION") {
    return {
      TYPE: "OPERATION",
      OP: expr.OP ?? "",
      ARGS: (expr.ARGS || []).map(cleanExpression),
    };
  }

  return { TYPE: expr.TYPE };
};

export const cleanRule = (rule) => {
  if (!rule || typeof rule !== "object") return rule;

  const r = { ...rule };

  if (r.TYPE === "RULE") {
    r.TRUE_STEP = (r.TRUE_STEP || []).map(cleanRule);
    r.FALSE_STEP = (r.FALSE_STEP || []).map(cleanRule);
  } else {
    delete r.TRUE_STEP;
    delete r.FALSE_STEP;
    delete r.CONDITION;
  }

  if (r.TYPE === "ITERATION") {
    r.RULES = (r.RULES || []).map(cleanRule);
  } else {
    delete r.RULES;
  }

  if (r.EXPRESSION) {
    r.EXPRESSION = cleanExpression(r.EXPRESSION);
  }

  if (r.TYPE === "REST") {
    ["BODY", "HEADERS", "URL_PARAMS"].forEach((k) => {
      r[k] = Array.isArray(r[k])
        ? r[k]
            .filter((i) => i.key && i.value)
            .reduce((acc, i) => ({ ...acc, [i.key]: i.value }), {})
        : {};
    });
  }

  return r;
};
